import { mutationFormat, cache_state } from '@u/vuexHelper';

export default {
	computed: {
		...mapState(["lang", "isLogin"]),
		ENV_TITLE() { return this.$tp("env.title") },
		cache() {
			return this.$store.getters.cache;
		},
	},
	data() {
		return {
			readySync: true,
		};
	},
	methods: {
		storeInit() { },
		cacheInit() {
			this.readySync = false;
			setTimeout(() => {
				let initialValue = new cache_state();

				// 保留 notifyToken
				const currentNotifyToken = this.cache.notifyToken;
				for (let key in initialValue) {
					this.$store.commit(`cache/${mutationFormat(key)}`, initialValue[key]);
				}

				// 恢復 notifyToken
				if (currentNotifyToken) {
					this.$store.commit("cache/SET_NOTIFY_TOKEN", currentNotifyToken);
				}

				this.readySync = true;

				localStorage.removeItem('VUEX_CACHE');
			}, 0);
		},
		syncTo() {
			localStorage.setItem('VUEX_CACHE', JSON.stringify(this.cache));
		},
	},
	watch: {
		cache: {
			handler() {
				if (this.readySync) this.syncTo();
			},
			deep: true,
		},
		isLogin: {
			handler(val) {
				if (val) {
				} else {
					this.storeInit();
					this.cacheInit();
					sessionStorage.clear();
					localStorage.clear();

					//不要動, 也不要改 appCallNavigate, 改了不知道為什麼反而能回上一頁
					this.$router.replace({ path: "/login" });
				}
			},
		},
		lang: {
			handler() {
				if (!this.lang) return false;
				this.$i18n.locale = this.lang;
				document.title = this.ENV_TITLE;
				DOM("body")[0].setAttribute("lang", this.lang)
				localStorage.setItem("VUEX_LANG", this.lang);
			},
			immediate: true
		},
	}
};
